import './chatbot.css';

// n8n Webhook für den FORGE Website-Chatbot
const WEBHOOK = 'https://schulz-solutions.app.n8n.cloud/webhook/forge-website-chat';

const GREETING = {
  de: ['Hallo! Ich bin MAX, Ihr FORGE-Assistent. 👋', '29 KI-Agenten. SAFe. OKR. Von der Idee bis zum Pull Request – vollautomatisch.', 'Was kann ich für Sie tun?'],
  en: ['Hello! I\'m MAX, your FORGE assistant. 👋', '29 AI agents. SAFe. OKR. From idea to pull request – fully automated.', 'How can I help you?']
};

const QUICK = {
  de: ['Was ist FORGE?', '29 Agenten erklärt', 'Welches Paket passt?', 'Demo anfragen'],
  en: ['What is FORGE?', '29 agents explained', 'Which plan fits?', 'Request a demo']
};

const LABELS = {
  de: { title: 'FORGE Assistent', header: 'FORGE Assistent · MAX', sub: '● Online · 29 Agenten bereit', close: 'Schließen', send: 'Senden', placeholder: 'Ihre Frage...' },
  en: { title: 'FORGE Assistant', header: 'FORGE Assistant · MAX', sub: '● Online · 29 agents ready', close: 'Close', send: 'Send', placeholder: 'Your question...' }
};

class ForgeChat {
  constructor() {
    this.lang = localStorage.getItem('forge_lang') || 'de';
    this.hist = [];
    this.open = false;
    this._render();
    GREETING[this.lang].forEach(t => this._msg('bot', t));
    // Portal-Sprachumschalter patcht die Seite live (kein Reload) — ohne diesen
    // Listener bliebe das Widget für seine gesamte Lebensdauer in der Sprache
    // hängen, die beim Erstconstruct galt (siehe lang.js::setLang → forge:langchange).
    window.addEventListener('forge:langchange', e => this.setLang(e.detail.lang));
  }

  // Aktualisiert nur die statische Chrome (Header/Labels/Platzhalter/Quick-Replies) —
  // bereits gesendete Chat-Nachrichten bleiben unverändert, wie in echten Chat-Apps üblich.
  setLang(lang) {
    if (lang !== 'de' && lang !== 'en') return;
    this.lang = lang;
    const l = LABELS[lang];
    const btn = document.getElementById('fch-btn');
    if (btn) btn.title = l.title;
    const htitle = document.querySelector('.forge-chat-htitle');
    if (htitle) htitle.textContent = l.header;
    const hsub = document.querySelector('.forge-chat-hsub');
    if (hsub) hsub.textContent = l.sub;
    const close = document.getElementById('fch-close');
    if (close) close.setAttribute('aria-label', l.close);
    const send = document.getElementById('fch-send');
    if (send) send.setAttribute('aria-label', l.send);
    if (this.inp) this.inp.placeholder = l.placeholder;
    const qc = document.getElementById('fch-quick');
    if (qc && qc.style.display !== 'none') {
      qc.innerHTML = '';
      QUICK[lang].forEach(q => {
        const b = document.createElement('button');
        b.className = 'forge-chat-q';
        b.textContent = q;
        b.onclick = () => { this.inp.value = q; this.send(); };
        qc.appendChild(b);
      });
    }
  }

  _render() {
    const l = LABELS[this.lang];
    const root = document.createElement('div');
    root.className = 'forge-chat-root';
    root.innerHTML = `
      <button class="forge-chat-btn" id="fch-btn" title="${l.title}">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
        </svg>
        <span class="forge-chat-badge"></span>
      </button>
      <div class="forge-chat-panel" id="fch-panel">
        <div class="forge-chat-header">
          <div class="forge-chat-avatar">M</div>
          <div class="forge-chat-hinfo">
            <div class="forge-chat-htitle">${l.header}</div>
            <div class="forge-chat-hsub">${l.sub}</div>
          </div>
          <button class="forge-chat-close" id="fch-close" aria-label="${l.close}">✕</button>
        </div>
        <div class="forge-chat-msgs" id="fch-msgs"></div>
        <div class="forge-chat-quick" id="fch-quick"></div>
        <div class="forge-chat-footer">
          <textarea class="forge-chat-inp" id="fch-inp" rows="1"
            placeholder="${l.placeholder}"></textarea>
          <button class="forge-chat-send" id="fch-send" aria-label="${l.send}">→</button>
        </div>
      </div>`;
    document.body.appendChild(root);

    this.panel = document.getElementById('fch-panel');
    this.msgs  = document.getElementById('fch-msgs');
    this.inp   = document.getElementById('fch-inp');

    document.getElementById('fch-btn').onclick  = () => this.toggle();
    document.getElementById('fch-close').onclick = () => this.toggle();
    document.getElementById('fch-send').onclick  = () => this.send();
    this.inp.addEventListener('keydown', e => {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); this.send(); }
    });

    const qc = document.getElementById('fch-quick');
    QUICK[this.lang].forEach(q => {
      const btn = document.createElement('button');
      btn.className = 'forge-chat-q';
      btn.textContent = q;
      btn.onclick = () => { this.inp.value = q; this.send(); };
      qc.appendChild(btn);
    });
  }

  toggle() {
    this.open = !this.open;
    this.panel.classList.toggle('open', this.open);
    if (this.open) setTimeout(() => this.inp.focus(), 240);
  }

  _msg(type, html) {
    const el = document.createElement('div');
    el.className = `forge-chat-msg forge-chat-msg-${type}`;
    el.innerHTML = html;
    this.msgs.appendChild(el);
    this.msgs.scrollTop = this.msgs.scrollHeight;
    return el;
  }

  async send() {
    const txt = this.inp.value.trim();
    if (!txt) return;
    this.inp.value = '';
    document.getElementById('fch-quick').style.display = 'none';
    this._msg('user', txt);
    this.hist.push({ role: 'user', content: txt });

    const typing = this._msg('bot', '<div class="forge-chat-typing"><span></span><span></span><span></span></div>');
    document.getElementById('fch-send').disabled = true;

    try {
      const r = await fetch(WEBHOOK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: txt, history: this.hist.slice(-8), lang: this.lang })
      });
      const d = await r.json();
      const reply = d.reply || d.text || d.message || d.output || '...';
      typing.innerHTML = reply;
      this.hist.push({ role: 'assistant', content: reply });
    } catch {
      typing.innerHTML = this.lang === 'en'
        ? 'Connection error – please <a href="#contact">send us a message</a>.'
        : 'Verbindungsfehler – bitte <a href="#contact">Nachricht senden</a>.';
    }

    document.getElementById('fch-send').disabled = false;
    this.msgs.scrollTop = this.msgs.scrollHeight;
  }
}

export function initChat() { new ForgeChat(); }
